import axios from 'axios';
import { getGuestTokenFromStorage, getTokenFromStorage } from '../shared';
import { isElectronApp } from '../services/crossPlatform/crossPlatformService';
import { API_USERS_LOGIN } from '../services/api/apiConst';

export const setRequestInterceptor = externalLoginURL => {
  if (isElectronApp()) {
    setElectronRequestInterceptor(externalLoginURL);
  } else {
    setWebRequestInterceptor();
  }
};

const setWebRequestInterceptor = () => {
  axios.interceptors.request.use(
    function(config) {
      if (!config.preventInterceptors) {
        let authToken = getTokenFromStorage() || getGuestTokenFromStorage();
        if (authToken && authToken.length > 0) {
          config.headers.authorization = `Bearer ${authToken}`;
          return config;
        }
      }
      return config;
    },
    function(error) {
      return Promise.reject(error);
    }
  );
};

const setElectronRequestInterceptor = externalLoginURL => {
  const loginUrl = externalLoginURL || API_USERS_LOGIN;
  axios.interceptors.request.use(
    function(config) {
      if (!config.preventInterceptors) {
        let authToken = getTokenFromStorage() || getGuestTokenFromStorage();
        if (authToken && authToken.length > 0) {
          config.headers.authorization = `Bearer ${authToken}`;
          return config;
        }

        if (shouldBeRejected(config.url)) {
          return Promise.reject(new Error(`No authToken found in localStorage for url ${config.url}`));
        }
      }
      return config;
    },
    function(error) {
      return Promise.reject(error);
    }
  );

  const shouldBeRejected = url => {
    return url.indexOf(loginUrl) === -1 && url.indexOf('/static/js/config.js') === -1;
  };
};
